import { TravellerWithCollectionMembershipsDTO } from '@/api/trafikportalen';
import {
  formatScheduledInactivation,
  getMembershipStatus,
} from '@/helpers/membershipStatus';
import { getTravellerStatus } from '@/helpers/status';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  IconCheckCircle,
  IconXMarkCircle,
  IconExclamationTriangle,
} from '@/icons';

export const TravellerStatus = ({
  traveller,
}: {
  traveller: TravellerWithCollectionMembershipsDTO;
}) => {
  const { formatMessage } = useIntl();
  const status = getTravellerStatus(traveller);
  const scheduledAt = traveller.memberships.find(
    (membership) => getMembershipStatus(membership) === 'will-inactivate',
  )?.inactivate_at;

  if (status === 'inactive') {
    return (
      <div className="flex w-fit items-center gap-1 rounded-full bg-background-400 px-2 text-sm text-text-800">
        <IconXMarkCircle className="size-4" aria-hidden="true" />
        <FormattedMessage defaultMessage="Inaktiv" />
      </div>
    );
  }

  if (status === 'will-inactivate' || status === 'pending-inactivation') {
    return (
      <div className="flex w-fit items-center gap-1 rounded-full bg-yellow-500 px-2 text-sm text-contrast-yellow">
        <IconExclamationTriangle className="size-4" aria-hidden="true" />
        {formatScheduledInactivation(formatMessage, scheduledAt)}
      </div>
    );
  }

  return (
    <div className="flex w-fit items-center gap-1 rounded-full bg-green-500 px-2 text-sm text-contrast-green">
      <IconCheckCircle className="size-4" aria-hidden="true" />
      <FormattedMessage defaultMessage="Aktiv" />
    </div>
  );
};
